import * as React from "react";
import type { SVGProps } from "react";

const SvgChartLine = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={26} height={21} {...props}>
        <path
            fill="currentColor"
            d="M25 19a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h1.419l4-7h4L14.6 4.683l4 2L22.132.5a1 1 0 1 1 1.736.992L19.4 9.317l-4-2L11.58 14h-4l-2.857 5Z"
        />
    </svg>
);
export default SvgChartLine;
